import State from '@/onsite/models/state.model';

const reinitializeTabs = (state: State) => {
  setTimeout(() => {
    let application = document.querySelector(".mdl-onsite-search") as HTMLElement & {
      instance: any;
    };
    Miele.ModuleLoader.initializeDataLoadModules()
    application.instance.initTabs()
    const body = document.body;
    body.classList.remove("loading");

    var activeTab = document.querySelector('.obj-tab-navigation__slide.active') as HTMLElement & { instance: any; }
    if (state.totalResults > 0 && activeTab === null) {
      activeTab = document.querySelector(`[data-tab-id="All"]`) as HTMLElement & { instance: any; }
      activeTab?.classList.add("active")
      var tabNavigation = document.querySelector('.obj-tab-navigation') as HTMLElement & { instance: any; }
      tabNavigation?.instance.setActiveByTabId("All")
    }

    if (state.initialTab !== "") {
      setTimeout(() => {
        var tabNavigation = document.querySelector('.obj-tab-navigation') as HTMLElement & { instance: any; }
        tabNavigation?.instance.setActiveByTabId(state.initialTab)
        state.initialTab = ""
      }, 100);
    }

  }, 1000);
};


const mutations = {
  SET_QUERY_STRING(state: State, queryString: string) {
    state.queryString = queryString
  },
  SET_LAST_QUERY_STRINGS(state: State) {
    const { lastQueryStrings, queryString } = state;
    
    if (!lastQueryStrings.includes(queryString)) {
      lastQueryStrings.unshift(queryString);
    }
  },
  SET_INITIAL_TAB(state: State, initialTab: string) {
    state.initialTab = initialTab
  },
  SET_SELECTED_TAB(state: State, selectedTab: string) {
    state.selectedTab = selectedTab
  },
  SET_TABS(state) {
    reinitializeTabs(state)
  },
  SET_ALL_TAB_SELECTED(state: State, status: boolean) {
    state.allTabSelected = status
  },
  SET_TOTAL_RESULTS(state: State) {
    let totalResults = 0
    totalResults += state.productGroup.totalResults
    state.groups.forEach(group => {
      totalResults += group.totalResults
    });
    state.totalResults = totalResults
  },
  SET_PRODUCTS(state, payload) {
    let config = payload.config
    let products = payload.products.grouped.ot_matNo_str.groups
    state.productGroup.results = []
    state.productGroup.totalResults = payload.products.grouped.ot_matNo_str.matches
    for (let p in products) {
      state.productGroup.results.push(
        {
          "matNo": products[p].doclist.docs[0].ot_matNo_str,
          "design": products[p].doclist.docs[0].ot_designType_str,
          "shortPos": products[p].doclist.docs[0].ot_shortPos_str,
          "label": products[p].doclist.docs[0].ot_productLabel_str,
          "img": products[p].doclist.docs[0].ot_img30Z04_str,
          "url": config.dsPath + products[p].doclist.docs[0].ot_filename_str,
          "hasProductdetails": products[p].doclist.docs[0].ot_hasProductdetails_str,
          "hasDownloads": products[p].doclist.docs[0].ot_hasDownloads_str
        }
      )
    }
  },
  ADD_PRODUCTS(state, payload) {
    let config = payload.config
    let products = payload.products.grouped.ot_matNo_str.groups
    for (let p in products) {
      state.productGroup.results.push(
        {
          "matNo": products[p].doclist.docs[0].ot_matNo_str,
          "design": products[p].doclist.docs[0].ot_designType_str,
          "shortPos": products[p].doclist.docs[0].ot_shortPos_str,
          "label": products[p].doclist.docs[0].ot_productLabel_str,
          "img": products[p].doclist.docs[0].ot_img30Z04_str,
          "url": config.dsPath + "-" + products[p].doclist.docs[0].ot_matNo_str + "-pp",
          "hasProductdetails": products[p].doclist.docs[0].ot_hasProductdetails_str,
          "hasDownloads": products[p].doclist.docs[0].ot_hasDownloads_str
        }
      )
    }
    // set active tab and scroll it into view
    var activeTab = document.querySelector('.obj-tab-navigation__slide.active a') as HTMLElement & { instance: any; }
    if (activeTab.getAttribute('data-tab-id') != 'products') {
      var tabNavigation = document.querySelector('.obj-tab-navigation') as HTMLElement & { instance: any; }
      var contentArea = document.querySelector('.mdl-onsite-search__content') as HTMLElement & { instance: any; }
      tabNavigation?.instance.setActiveByTabId("products")
      contentArea?.scrollIntoView()
    }
  },
  SET_GROUPS(state, payload) {
    let config = payload.config
    let results = payload.results
    let groupResults: any[] = []
    let groupNumberFound: number = 0
    let projectResults: any[]
    let web20TotalResults: number = 0
    let web20ResultsLoaded: number = 0
    state.groups = []
    for (let group in config) {
      let currentGroup = results.find(element => element.id === config[group].id)
      groupResults = []
      groupNumberFound = 0
      if (currentGroup) {
        projectResults = currentGroup.web20.response.docs
        web20TotalResults = currentGroup.web20.response.numFound
        web20ResultsLoaded = projectResults.length
        groupNumberFound += currentGroup.web20.response.numFound
        if (projectResults.length > 0) {
          for (let doc in projectResults) {
            groupResults.push(
              {
                "id": "web20" + projectResults[doc].CIS_ID,
                "headline": projectResults[doc].title,
                "description": "",
                "url": projectResults[doc].ot_pageURL_str,
                "score": projectResults[doc].score
              }
            )
          }
        }
      }
      state.groups.push(
        {
          "id": config[group].id,
          "name": config[group].name,
          "detailView": false,
          "web20TotalResults": web20TotalResults,
          "web20ResultsLoaded": web20ResultsLoaded,
          "totalResults": groupNumberFound,
          "results": groupResults.sort((a, b) => -1 * (a.score - b.score))
        }
      )
    }
  },
  ADD_GROUP_RESULTS(state, payload) {
    let projectResults: any[]
    let groupResults: any[] = []
    let currentGroup = payload.group
    let group = state.groups.find(group => group.id === currentGroup.name)
    if (currentGroup) {
      if (currentGroup.web20.response) {
        projectResults = currentGroup.web20.response.docs
        if (projectResults.length > 0) {
          for (let doc in projectResults) {
            groupResults.push(
              {
                "id": "web20" + projectResults[doc].CIS_ID,
                "headline": projectResults[doc].title,
                "description": "",
                "url": projectResults[doc].ot_pageURL_str,
                "score": projectResults[doc].score
              }
            )
          }
          group.web20ResultsLoaded += projectResults.length
        }
      }
      group.results = [...group.results,...groupResults.sort((a, b) => -1 * (a.score - b.score))]

      // set active tab and scroll it into view
      var activeTab = document.querySelector('.obj-tab-navigation__slide.active a') as HTMLElement & { instance: any; }
      if (activeTab.getAttribute('data-tab-id') != group.name.trim().toLowerCase()) {
        var tabNavigation = document.querySelector('.obj-tab-navigation') as HTMLElement & { instance: any; }
        var contentArea = document.querySelector('.mdl-onsite-search__content') as HTMLElement & { instance: any; }
        tabNavigation?.instance.setActiveByTabId(group.name.trim().toLowerCase())
        contentArea?.scrollIntoView()
      }
  

    }
  }

};

export default mutations;
